// extracted by mini-css-extract-plugin
export default {"terms":"terms_terms__CdiuL","title":"terms_title__RViUA"};